module.exports = __webpack_public_path__ + "img/van02.6bdd7d77.png";